import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  isPageLoading: false,
  all: {},
}

// getters
export const getters = {
  getPageByIndex: ({ all }) => ({ index }) => all[index] || null,
}
// mutations
export const mutations = {
  fetchPageStarted(state) {
    state.isPageLoading = true
  },
  fetchPageSuccess(state, { index, page }) {
    Vue.set(state.all, index, page)
    state.isPageLoading = false
  },
  fetchPageFailed(state) {
    state.isPageLoading = false
  },
}
// actions
export const actions = {
  async fetchPageByIndex({ commit, state: { all }, getters }, { index }) {
    if (typeof all[index] !== 'undefined' || getters.getPageByIndex({ index })) {
      return all[index]
    }
    let response = null
    try {
      commit('fetchPageStarted', { index })
      response = await axios.get(`content/page/${index}`)
      commit('fetchPageSuccess', {
        index,
        page: response.page,
      })
    } catch (e) {
      commit('fetchPageFailed', { index })
    }
    return response
  },
}
